import React from "react";
import CanvasComponent from "./Canvas";
import LogoComponent from "./Logo";
import NavHeader from "./NavHeader";
import NavbarSidebarComponent from "./NavSidebar";
import "../assets/css/style.css"
import "../assets/css/style_extra.css"
import $ from 'jquery'
import PopModalComponent from "./Modal/index";
import LoaderComponent from "./Loader";
import Slider from "./Slider";
import MobileHumberger from "./NavSidebar/mobile_humberger";
import NavTab from "./NavBottom/tab";
import GuidedPath from "./NavBottom/guided_path";
import { fyponSliderArr, home1HotspotArr } from "../data/constant"
import HomeComponent from "./Home";
import AudioComponent from "./Util/AudioComponent";
import KeysuccessRotation from "./KeysuccessRotations";
import DirectionRotation from "./Util/DirectionRotation";
import Canvas2d from "./Canvas/canvas2d";
import ProfileComponent from "./NavHeader/ProfileComponent";
import FavouriteComponent from "./NavHeader/FavouriteComponent";
import { fetchVideoList, fetchUserDetails, callAnalyticsAPIOther } from "../api/user"
// import WelcomeGraphics from "./Util/WelcomeGraphics";

const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;


const { availWidth, availHeight } = window.screen, screenWidth = Math.max(availWidth, availHeight), screenHeight = Math.min(availWidth, availHeight);
const device = getDevice(), testMode = '';

function getDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) { return "windows"; }
    if (/android/i.test(userAgent)) { return "android"; }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return "ios"; }
    // if(isIOS()) {
    //     return "ios";
    // }
    // if(isIpadOS()) {
    //     return "ios";
    // }
    return undefined;
}

function isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    } else {
        return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    }
}

function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
class MainComponent extends React.PureComponent {

    constructor(props) {

        super(props)
        const { innerWidth, innerHeight } = window, dir = innerWidth > innerHeight ? 'land' : 'port';
        this.state = {
            popModalShow: false,
            popModalBody: [],
            currentScene: 'welcome',
            isLoading: false,
            loadingCount: 10,
            pageKey: 'home',
            navigationActiveState: true,
            tSize: { w: innerWidth, h: innerHeight, l: 0 }, dir,
            logoKey: 'thermatru',
            selMenu: 'welcome',
            sidebarToggle: true,
            device: device,
            navslidervisibility: false,
            navtabvisibility: false,
            guidedPathvisibility: false,
            popupModalContentObj: null,
            logoType: '',
            navHeaderVisibility: true,
            sliderObj: {
                key: 'home1',
                oldImage: baseUrl + 'datas/fypon/fyponexplore/home1/Building Block Before HD.png',
                newImage: baseUrl + 'datas/fypon/fyponexplore/home1/Building Block After HD.png',
                hotspots: home1HotspotArr
            },
            speaker: false,
            navHeaderExitVisibility: false,
            resourceLoad: false,
            userSubmited: false,
            dir: null,
            currentCubempatArrayIndexName: "",
            favModalVisible: false,
            prevScene: null,
            profileVideos: null,
            isSmeUser: false,
        }
        this.canvas2dtexture = null
    }


    componentDidUpdate(prevProps) {

        if (this.props.userSubmited !== prevProps.userSubmited) {

            let user_id = sessionStorage.getItem("user_id");
            let that = this
            if (user_id) {
                fetchUserDetails(user_id).then((val) => {


                    if(val.data.is_registered === 0){

                        this.setModalPopupContent('profile_edit')
                    }
                    if (val.data.user) {
                        if (val.data.user.is_sme === 1) {

                            that.setState({ isSmeUser: true })
                        }
                    }
                })
            }
            
            // if(process.env.REACT_APP_WELCOME_SCREEN === "show") {
            //     $("#welcomegraphicsmodal").modal('show')

            // }
           // this.setModalPopupContent('welcome_info')

        }
    }
    componentDidMount() {


        this.setCanvasSize();
        window.addEventListener('resize',this.setCanvasSize);

        if (device === undefined) {

            this.setState({ navigationActiveState: true })
        } else {

            const mediaQuery = window.matchMedia('(max-width: 991px)')

            if (mediaQuery.matches) {

                const userAgent = navigator.userAgent.toLowerCase();
                const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    
                if(!isTablet) {

                    this.setState({ navigationActiveState: false, device: device, sidebarToggle: false })

                    
                }



            } else {

                this.setState({ navigationActiveState: true })
            }


        }

        const queryParams = new URLSearchParams(window.location.search)
        const email = queryParams.get("email")
        if (email) {

            this.changeRender360Map("prmedia")
        }

    }

    setCanvasSize = () => {

     
        const { innerWidth, innerHeight } = window, dir = innerWidth > innerHeight ? 'land' : 'port';
        const pageWidth = dir==='land'?screenWidth:screenHeight, pageHeight = dir==='port'?screenWidth:screenHeight;
        const w = device==='ios'?pageWidth:innerWidth;
        const m = device?w*0.7:1000;
        let direction = ""
        if(window.innerHeight > window.innerWidth){
            direction = "port"
        }else{
            direction = "land"

        }
       // alert(direction);

        this.setState({ dir : direction, tSize: { w: window.innerWidth, h: window.innerHeight } });
        //this.setState({dir, tSize:{w, h:innerHeight, l:(innerWidth-w)/2, m}}, () => { });
    }

    setModalPopupContent = (content_obj) => {

        $(".modalVisibleUiHide").hide();
        this.setState({ popupModalContentObj: content_obj, popModalShow: true, speaker: false })
    }

    updateModalContent = (content, status) => {
        this.setState(prevState => ({
            popModalBody: [...prevState.popModalBody, content],
            popModalShow: status
        }))


    }


      menuSideBarLinkActive = (selScene) => {

        
        $(".colaps").removeClass('active_arrow')


        document.querySelectorAll('.dropdown_item').forEach(element => {
            element.style.color = "#4e4e4e"
        })

        if(selScene === "prmedia"){

            $("#media").css('color', '#E91E23')
            $("#therma").next('ul').removeClass('collapsed')
            $("#fypon").next('ul').removeClass('collapsed')
            $("#fypon").css('color', '#4e4e4e')
            $("#therma").css('color', '#4e4e4e')

        }

        if (selScene === "fypon_advantage" || selScene === "fypon_new_products" || selScene === "tools_support_fypon") {
            $("#media").css('color', '#4e4e4e')

            $("#therma").next('ul').removeClass('collapsed')
            $("#fypon").css('color', '#0079C1')
            $("#fypon").next('ul').addClass('collapsed')
            $("#fypon").addClass("active_arrow")
            $("#therma").css('color', '#4e4e4e')
            $("#" + selScene).css('color', '#0079C1')
            if(selScene === "tools_support_fypon"){
                setTimeout(() => {
                    document.getElementById("tools_support_fypon2").style.color = "#0079C1";
                },10)
            }
        }

        if (selScene === "thermatru_difference" || selScene === "thermatru_new_products" || selScene === "thermatru_tools_support" || selScene === "thermatru_key_success") {
            $("#media").css('color', '#4e4e4e')

            $("#fypon").next('ul').removeClass('collapsed')
            $("#fypon").css('color', '#4e4e4e')
            $("#therma").css('color', '#E91E23')
            $("#therma").next('ul').addClass('collapsed')
            $("#therma").addClass("active_arrow")
            $("#" + selScene).css('color', '#E91E23')

            if(selScene === "thermatru_tools_support"){

                setTimeout(() => {
                    document.getElementById("thermatru_tools_support2").style.color = "#E91E23";

                },10)

            }
        }


    }
    canvasSceneChange = (changeScene) => {

        this.menuSideBarLinkActive(changeScene)

        if (changeScene === "prmedia") {
            $(".logo-cls").removeClass("d-none");
            $("#fypon-logo").addClass('d-none')


            this.setState({
                currentScene: changeScene,
                selMenu: changeScene,
                pageKey: 'canvas-2d',
                logoKey: 'thermatru',
                popModalShow: false,
            });

        } else {

            this.setState({
                currentScene: changeScene,
                selMenu: changeScene,
                pageKey: 'canvas',
                logoKey: 'thermatru',
                popModalShow: false,
            });
        }


    }

    updateLoadingCount = (count) => {

        this.setState({ loadingCount: count })
    }
    changeLoaderStatus = (status) => {

        this.setState({ isLoading: status })
    }

    setGuidedView = (changeType) => {

        if (changeType === "show") {

            this.setState({
                currentScene: 'thermatru_difference',
                selMenu: 'thermatru_difference',
                pageKey: 'canvas',
                logoKey: 'thermatru',
                guidedPathvisibility: true,
                popModalShow: false,
                navslidervisibility: false,
                navtabvisibility: false
            });

            $(".mainmenu > li").css({ 'pointer-events': 'none' })

            this.menuSideBarLinkActive("thermatru_difference")

        }
        else {

       
            $(".mainmenu > li > a").css('color', '#4e4e4e')
            this.setState({ guidedPathvisibility: false })
            $(".mainmenu > li").css({ 'pointer-events': '' })

        }

    }

    changeRender360Map = (selMenu, iseventsidebar = false) => {


        let prevScene = this.state.selMenu;
        let pageKey = 'canvas'
        let navslider = true
        let navtab = false
        if (selMenu === "fypon_explore" && iseventsidebar) {
            pageKey = 'slider';
            navtab = true
        }
        if (selMenu === "rotation_keysuccess" && iseventsidebar) {
            pageKey = 'keysuccess';
        }

        if (selMenu === "prmedia") {
            pageKey = 'canvas-2d';
            $(".logo-cls").removeClass("d-none");
            $("#fypon-logo").addClass('d-none')
        }



        this.setState({
            prevScene,
            selMenu,
            pageKey,
            popModalShow: false,
            modalVisibleUiHide: false,
            navslidervisibility: navslider,
            navtabvisibility: navtab,
            navHeaderVisibility: true,
        });

        this.hideSideBar()

    }

    
    hideSideBar = () => {
        if(device !== undefined) {


            const userAgent = navigator.userAgent.toLowerCase();
            const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

            if(!isTablet) {

                this.setState({ sidebarToggle: false})

            }
        }
    }

    handleSideBarToggle = () => {


        this.setState({ sidebarToggle: !this.state.sidebarToggle })
    }

    renderSliderScene = (obj) => {

        this.setState({ isLoading: true, loadingCount: 0 })

        const renderObj = fyponSliderArr.find(item => item.key === obj);
        if (!renderObj) return false;

        this.setState({ sliderObj: renderObj, popModalShow: false })

    }

    endTime = (startTime) => {

        startTime = parseFloat(startTime);
        let endTime = new Date();
        endTime = Date.parse(endTime);
        let timeDiff = endTime - startTime; //in ms
        timeDiff /= 1000;
        let seconds = Math.round(timeDiff);
        return seconds
    }


    handleExist = (selscen) => {

        //send analytics fypon explore
        const reqData = {}
        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {

            reqData.user_id = user_id;
            reqData.area_id = "fypon_explore";
            reqData.resource_id = "fypon_explore";
            reqData.resource_type = "area";
            reqData.prev_area = "fypon_explore"
            reqData.spent_time = 0;
            reqData.total_time = 0;
            reqData.video_status = "";
            reqData.download = 0;
            reqData.guided_mode = 0;
            let strttime = sessionStorage.getItem("started_time")
            if (strttime) {
                reqData.spent_time = this.endTime(strttime)
            }

            callAnalyticsAPIOther(reqData)
        }

        this.setState({
            pageKey: 'canvas',
            sidebarToggle: true,
            navHeaderExitVisibility: false,
        })

        this.changeRender360Map(selscen);
    }

    handleRedirectHome = () => {

        $(".logo-cls").removeClass("d-none");
        $("#fypon-logo").addClass('d-none')
        this.setState({ pageKey: 'home',selMenu: 'welcome'})
        this.hideSideBar()
        $(".colaps").removeClass('active_arrow')
                   
        document.querySelectorAll('.submenu').forEach(element => {
            element.previousSibling.style.color = "#4e4e4e"
            element.classList.remove("collapsed")
        })

    }
    handleSpeaker = () => {

        this.setState({ speaker: !this.state.speaker })

    }


    handleSideBar = () => {

        this.setState({ sidebarToggle: true })
    }

    handlechangeModalShowStatusFals = () => {

        this.setState({ popModalShow: false })

    }

    handlechangeModalContent = (val) => {

        this.setState({ popupModalContentObj: val })
    }

    handleExploreUiVisibility = () => {

        this.setState({
            sidebarToggle: false,
            navHeaderVisibility: false,
            navHeaderExitVisibility: true
        })
    }

    handlehideSidebar = () => {

        this.setState({ sidebarToggle: false })
    }

    handleupdateGuidedPathArrayIndex = (cubemapname) => {

        this.setState({ currentCubempatArrayIndexName: cubemapname })
    }


    handleFavoriteVisibility = (status) => {

        this.setState({ favModalVisible: status })
    }

    handlecallProfileApiStatus = () => {

        let user_id = sessionStorage.getItem("user_id");
        if (user_id) {

            let uservideos = fetchVideoList({ user_id: user_id });

            uservideos.then(val => {

                this.setState({ profileVideos: val.data.video_list })
            })

        }

    }


    render() {
        const { isLoading, pageKey, selMenu, tSize, guidedPathvisibility } = this.state;
        return (
            <div style={{ opacity: (this.props.userSubmited) ? '1' : '0', width: tSize.w, height: tSize.h }}>
                <div className="modalVisibleUiHide" style={{ width: tSize.w, height: tSize.h }}>
                    <LogoComponent />

                    <NavHeader
                        visibility={this.state.navHeaderVisibility}
                        exitBtnvisible={this.state.navHeaderExitVisibility}
                        pageKey={pageKey}
                        extToExplore={this.handleExist}
                        handleFavoriteVisibility={this.handleFavoriteVisibility}
                        callProfileApiStatus={this.handlecallProfileApiStatus}
                    />
                    <MobileHumberger toggleSideBar={this.handleSideBarToggle} />
                    <NavbarSidebarComponent
                        navigationDisplay={this.state.navigationActiveState}
                        canvasSceneChange={this.canvasSceneChange}
                        changeRender360Map={this.changeRender360Map}
                        setGuidedView={this.setGuidedView}
                        sidebarToggle={this.state.sidebarToggle}
                        redirectToHome={this.handleRedirectHome}
                        speaker={this.state.speaker}
                        setSpeaker={this.handleSpeaker}
                        setModalPopupContent={this.setModalPopupContent}
                        isSmeUser={this.state.isSmeUser}
                        handlehideSidebar={this.handlehideSidebar}
                    />
                    {
                        this.state.pageKey === "slider" &&
                        <NavTab
                            visible={this.state.navtabvisibility}
                            setModalPopupContent={this.setModalPopupContent}
                            renderSliderScene={this.renderSliderScene}
                        />
                    }
                    {

                        this.state.guidedPathvisibility && <GuidedPath visible={this.state.guidedPathvisibility}
                            canvasSceneChange={this.canvasSceneChange}
                            setGuidedView={this.setGuidedView}
                            currentCubempatArrayIndexName={this.state.currentCubempatArrayIndexName}
                            handleupdateGuidedPathArrayIndex={this.handleupdateGuidedPathArrayIndex}
                        />
                    }

                    <AudioComponent speaker={this.state.speaker} />
                    <HomeComponent
                        deviceDirection={this.state.dir}
                        tSize={tSize}
                        pageKey={pageKey}
                        selMenu={selMenu}
                        showSidebar={this.handleSideBar}
                        device={this.state.device}
                        changeRender360Map={this.changeRender360Map}
                    />
                </div>
                <CanvasComponent
                    deviceDirection={this.state.dir}
                    tSize={tSize}
                    pageKey={pageKey}
                    selMenu={selMenu}
                    device={this.state.device}
                    guidedPathvisibility={guidedPathvisibility}
                    changeLoaderStatus={this.changeLoaderStatus}
                    setModalPopupContent={this.setModalPopupContent}
                    changeRender360Map={this.changeRender360Map}
                    hideSidebar={this.handlehideSidebar}
                    sidebarToggle={this.state.sidebarToggle}
                    handleExploreUiVisibility={this.handleExploreUiVisibility}
                    updateGuidedPathArrayIndex={this.handleupdateGuidedPathArrayIndex}
                />


                <Canvas2d
                    deviceDirection={this.state.dir}
                    prevScene={this.state.prevScene}
                    prmediatext={this.canvas2dtexture}
                    tSize={tSize}
                    pageKey={pageKey}
                    selMenu={selMenu}
                    guidedPathvisibility={guidedPathvisibility}
                    changeLoaderStatus={this.changeLoaderStatus}
                    setModalPopupContent={this.setModalPopupContent}
                    changeRender360Map={this.changeRender360Map}
                    hideSidebar={this.handlehideSidebar}
                    sidebarToggle={this.state.sidebarToggle}
                    handleExploreUiVisibility={this.handleExploreUiVisibility}
                    updateGuidedPathArrayIndex={this.handleupdateGuidedPathArrayIndex}
                />



                {
                    this.state.pageKey === 'keysuccess' && <KeysuccessRotation
                        pageKey={pageKey}
                        device={this.state.device}
                        changeLoaderStatus={this.changeLoaderStatus}
                        setModalPopupContent={this.setModalPopupContent}
                        isLoading={this.state.isLoading}
                    />
                }
                {
                    this.state.pageKey === "slider" && <Slider
                        tSize={tSize}
                        pageKey={pageKey}
                        selMenu={selMenu}
                        device={this.state.device}
                        setModalPopupContent={this.setModalPopupContent}
                        changeLoaderStatus={this.changeLoaderStatus}
                        sliderObj={this.state.sliderObj}
                    />
                }
                <PopModalComponent
                    prevScene={this.state.selMenu}
                    device={this.state.device}
                    show={this.state.popModalShow}
                    bodycontent={this.state.popModalBody}
                    changeModalShowStatusFals={this.handlechangeModalShowStatusFals}
                    changeLoaderStatus={this.changeLoaderStatus}
                    popupModalContentObj={this.state.popupModalContentObj}
                    changeModalContent={this.handlechangeModalContent}
                    changeRender360Map={this.changeRender360Map}

                />
                <LoaderComponent isLoading={isLoading} loadingCount={this.state.loadingCount} />
                <DirectionRotation deviceDirection={this.state.dir} tSize={tSize} />
                <FavouriteComponent
                                    device={this.state.device}
                    changeLoaderStatus={this.changeLoaderStatus}
                    favModalVisible={this.state.favModalVisible}
                    handleFavoriteVisibility={this.handleFavoriteVisibility}
                />
                {/* <WelcomeGraphics /> */}
                {

                    this.props.userSubmited && <ProfileComponent setModalPopupContent={this.setModalPopupContent}
                        profileVideos={this.state.profileVideos} />
                }

                {/* <EditAccountForm />  */}
            </div>
        )
    }
}



export default MainComponent;